import React, { useReducer } from "react";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router";

// Routes
import * as paths from "../../../routes/paths";

// redux
import { connect } from "react-redux";

// @material-ui/core
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";

// shared core components
import SlickCarousel from "../../../shared/components/SlickCarousel/SlickCarousel";
import TitleLink from "../../../shared/components/TitleLink/TitleLink";
import TabCarousel from "../../../shared/components/Tabs/TabCarousel";
import { log } from "../../../shared/utils/console.js";
import { validateMembership } from "../../utils/membershipUtils.js";
import { manuallyAttemptMembershipPayment as attemptMembershipPayment } from "../../utils/membershipRepurchase.js";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { applyCart, applyCartProducts } from "../../../redux/actions/cartActions.js";
import { CART } from "../../../routes/paths";

// services
import { CourseService, MarketPlaceService, MembershipService } from "@sdk-point/talisis";
import * as imageSource from "../../../shared/utils/imageSource";

// Design-system
import { ACCESS_ACTION } from "../../../design-system/constants/access-action.js";
import StatusCourseCard from "../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard.jsx";
import { getSourceBySourceAndCompany } from "../../../design-system/utils/source.js";
import { convertSourceToImageResource } from "../../../constants/placeholderImages.js";

// constants 
import { SOURCES } from "../../constants/sources";


import CoursesProvider from "./context/CoursesProvider";
import coursesReducer, { initialCourses, types } from "./context/CoursesReducer";

import { SwiperSlide } from "swiper/react/swiper-react.js";
import { v4 as uuid } from "uuid";
import NothingFound from "../NothingFound/NothingFound";
import clsx from "clsx";
import CourseCardSkeleton from "../Card/CardSkeletonLoading/CourseCardSkeleton";
import { eventData, eventTracker } from "../EventTracker/EventTracker";

const tabs = [
  { value: "Todos", uuid: uuid() },
  { value: "Populares", uuid: uuid() },
  { value: "Nuevas", uuid: uuid() },
];

// Fallback para endpoints que todavía no envían typeLabel.
const alliesFree = [
    SOURCES['GOOGLE'],
    SOURCES['HUBSPOT']
]

// Espejo de lib-talisis/src/functions/membership.ts
const TYPE_LABEL = {
    FREE: 1,
    OTHER_MEMBERSHIP: 2,
    INCLUDE_MEMBERSHIP: 3,
    PRICE: 4,
};

/**
 * Resuelve qué acción ofrecer sobre la tarjeta a partir del entitlement que
 * envía el API. `membershipExpired` solo aplica a los cursos que la membresía
 * del alumno sí cubre.
 */
const resolveAccessAction = (course, membershipExpired) => {
    switch (course?.typeLabel) {
        case TYPE_LABEL.FREE:
            return ACCESS_ACTION.ENROLL;
        case TYPE_LABEL.INCLUDE_MEMBERSHIP:
            // typeLabel 3 implica cobertura, pero si el API la niega gana is_included.
            if (course?.is_included === false) return ACCESS_ACTION.UPGRADE;
            return membershipExpired ? ACCESS_ACTION.RENEW : ACCESS_ACTION.ENROLL;
        case TYPE_LABEL.OTHER_MEMBERSHIP:
            return ACCESS_ACTION.UPGRADE;
        case TYPE_LABEL.PRICE:
            return ACCESS_ACTION.DETAIL;
        default: {
            const gated = alliesFree.includes(course?.source_id) ? false : membershipExpired;
            return gated ? ACCESS_ACTION.RENEW : ACCESS_ACTION.ENROLL;
        }
    }
};

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    maxWidth: theme.breakpoints.maxWidth.desktop,
    margin: "auto",
    padding: (props) => (!!props.withoutPaddings ? "" : "32px 0 62px"),
    minHeight: (props) => (!!props.withoutPaddings ? 470 : 576),
    [theme.breakpoints.down("xs")]: {
      minHeight: "0px !important",
      padding: "24px 0px !important",
    },
  },
  carousel: {
    "& .slick-list": {
      "& .slick-track": { display: "flex", flexFlow: "nowrap" },
      "& .slick-slide": { width: "312px" },
    },
    [theme.breakpoints.down("xs")]: { padding: "0px", marginLeft: 16 },
  },
  hover_carousel_detail: {
    "& > h4": { marginLeft: "0px" },
    "& > div": { paddingLeft: "0px", paddingRight: "0px" },
  },
  hover_carousel: {
    "&:hover": { "& h4": { "& button": { background: "transparent" } } },
    "@media (max-width: 768px)": { "& h4": { "& button": { background: "transparent" } } },
  },
  buttonGroup: {
    position: "absolute",
    bottom: 0,
    right: 0,
    margin: `${theme.spacing(1)}px 0px`,
    [theme.breakpoints.down("xs")]: { margin: "0px" },
  },
  title: {
    marginLeft: "59px",
    width: "100%",
    "@media (max-width: 1250px)": { marginLeft: "5px" },
  },
  card: {
    padding: "12px",
    maxWidth: "fit-content",
    [theme.breakpoints.down("xs")]: { padding: "8px" },
  },
  cardActionArea: { position: "relative", maxWidth: "286px" },
  tabMain: {
    "& .MuiTabs-root": {
      marginBottom: "20px",
      maxWidth: theme.breakpoints.maxWidth.desktop,
      marginLeft: "68px",
    },
  },
  titleLink: { paddingLeft: 0 },
}));

function transformDataPriceMembership(data) {
  return data.map((course) => ({
    ...course,
    company_id: course.company,
    source_id: course.source,
    priceMembershipActions: true,
    price: { number: course.price, listNumber: course.list_price },
    image_url: course.image || imageSource.convertSourceToImageResource(course.company, course.source),
  }));
}

const CourseCarousel = (props) => {
  const {
    id, user, handleSetChargeStatusForOptimize, handleChangeTabSaved,
    type, viewCourseDetails, isMyCourses, course_id, isDetail, showTabs,
    title, withoutPaddings, noDataFound, clickFrom, hideShowMoreResponsive,
  } = props;

  const classes = useStyles({ withoutPaddings });
  const history = useHistory();

  const [hiddeCarouselByEmpty, setHiddeCarouselByEmpty] = React.useState(false);
  const [dynamicTitleLink, setDynamicTitleLink] = React.useState("Conoce nuestros cursos de educación continua");
  const [lengthCarousel, setLengthCarousel] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [membershipExpired, setMembershipExpired] = React.useState(false);
  const [userMembership, setUserMembership] = React.useState(null);
  const [userAddOn, setUserAddOn] = React.useState(null);
  const [loadingRepurchase, setLoadingRepurchase] = React.useState(false);
  const dispatchCart = useDispatch();
  const { cart } = useSelector((state) => state.cartReducer);
  const [coursesState, dispatch] = useReducer(coursesReducer, initialCourses);
  const [value, setValue] = React.useState(0);
  const [finishSearch, setFinishSearch] = React.useState(false);
  const { courses } = coursesState;

  const courseService = new CourseService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
  const marketService = new MarketPlaceService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
  const membershipService = new MembershipService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

  const getFavorites = async () => {
    let coursesData = [];
    const favorite = await courseService.getUserFavoriteCourses(user.person_id);
    if (favorite?.response?.length > 0) {
      coursesData = favorite.response.length > 10
        ? favorite.response.slice(0, 10)
        : favorite.response.slice();
    }
    handleSetChargeStatusForOptimize("favorites");
    return coursesData;
  };

  const getData = async () => {
    try {
      let coursesData = [];
      setLoading(true);
      if (id === "favorites") {
        coursesData = (await getFavorites()).slice();
      } else if (id === "recommendations") {
        const typeRecommendation = type != null ? type : "generic";
        const recommended = await courseService.getCoursesRecommendedByType(user.person_id, typeRecommendation);
        if (recommended?.data?.courses?.length > 0) {
          if (typeRecommendation === "consumo" || typeRecommendation === "interes") {
            recommended.data.courses = recommended.data.courses.map((course) => ({
              ...course,
              company_id: course.company,
              source_id: course.source,
              priceMembershipActions: true,
              price: { number: course.price, listNumber: course.list_price },
              image_url: imageSource.convertSourceToImageResource(course.company, course.source),
            }));
            if (typeRecommendation === "consumo" && !!recommended.data.titleLink.length)
              setDynamicTitleLink("Por que cursaste " + recommended.data.titleLink);
            if (typeRecommendation === "interes")
              setDynamicTitleLink("Más cursos sobre lo que te interesa");
          }
          coursesData = recommended.data.courses.slice();
        }
        if (handleSetChargeStatusForOptimize) handleSetChargeStatusForOptimize("generic");
        setFinishSearch(true);
      } else if (id === "courseDetail") {
        if (course_id) {
          const recommended = await courseService.getCoursesRecommendedByCourseId(user.person_id, "courseDetail", course_id);
          if (recommended?.data?.length > 0) {
            setDynamicTitleLink(title || "Te recomendamos");
            const temp = transformDataPriceMembership(recommended?.data);
            if (temp?.length > 0) coursesData = temp.slice();
          }
        }
      } else if (id && id.includes("catalog::")) {
        const op = id.split("::")[1];
        if (op === "educon_courses" || op === "popular_courses") {
          const temp = transformDataPriceMembership(await marketService.getCoursesRecommended(op, user.person_id, 0, 20));
          if (temp?.length > 0) coursesData = temp.slice();
        } else {
          const temp = (await marketService.getCoursesRecommended(op, user.person_id, 0, 20))
            .filter((it) => it.source !== SOURCES.AWS_SKILL_BUILDER)
            .map((course) => ({
              ...course,
              priceMembershipActions: true,
              price: { number: course.price, listNumber: course.list_price },
              image_url: course.image || imageSource.convertSourceToImageResource(course.company, course.source),
            }));
          if (temp?.length > 0) coursesData = temp.slice();
        }
      } else if (id && id.includes("escuela::")) {
        const ou = id.split("::")[1];
        const recommended = await courseService.getCoursesRecommendedByType(user.person_id, "escuela", ou);
        const temp = transformDataPriceMembership(recommended?.data?.courses);
        if (temp?.length > 0) coursesData = temp.slice();
      } else {
        const typeRecommendation = type != null ? type : "generic";
        const recommended = await courseService.getCoursesRecommended(user.person_id, typeRecommendation);
        if (recommended?.courses?.length > 0) coursesData = recommended.courses.slice();
      }
      return coursesData;
    } catch (e) {
      log(e?.message);
      //Retornamos arreglo vacio para que el render nunca reciba undefined
      return [];
    }
  };

  const getMembership = async () => {
    try {
      const result = await membershipService.getPersonMembershipDetail(user.person_id);
      setUserMembership(result?.userMembership);
      setUserAddOn(result?.userAddOn);
      setMembershipExpired(validateMembership(result?.userMembership));
    } catch (error) {log(error?.message);
    }
  };

  const manuallyAttemptMembershipPayment = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await attemptMembershipPayment({
      userMembership,
      userAddOn,
      cart,
      user,
      dispatchCart,
      applyCart,
      applyCartProducts,
      history,
      cartPath: CART,
      setLoadingRepurchase,
    });
  };

  React.useEffect(() => {
    let isCanceled = true;
    setDynamicTitleLink(title);

    const init = async () => {
        await getMembership();
        const data = await getData();
        if (isCanceled) {
            if (!data || data?.length === 0) {
            setLengthCarousel(0);
            setHiddeCarouselByEmpty(true);
            } else {
            setLengthCarousel(data?.length);
            setHiddeCarouselByEmpty(false);
            }
            dispatch({ type: types.addCourses, payload: data });
            setLoading(false);
        }
    };

    init().catch((err) => log(`Failed: ${err}`));

    return () => (isCanceled = false);
  }, []);

  const handleClickInTitle = (e) => {
    e.preventDefault();
    if (id === "favorites") {
      handleChangeTabSaved();
    } else if (id === "catalog::educon_courses") {
      history.push(`${paths.BUSQUEDA}?educon=true`);
    } else if (id === "catalog::discovery_courses") {
      history.push(`${paths.BUSQUEDA}?explorar=true`);
    } else {
      history.push(`${paths.BUSQUEDA}?explorar=true`);
    }
  };

  const handleChange = (event, newValue) => {
    event.preventDefault();
    setLoading(true);
    if (newValue === 0) {
      getData()
        .then((data) => {
          if (!data || data?.length === 0) {
            setLengthCarousel(0);
            setHiddeCarouselByEmpty(true);
          } else {
            setLengthCarousel(data?.length);
            setHiddeCarouselByEmpty(false);
          }
          dispatch({ type: types.addCourses, payload: data });
          setLoading(false);
        })
        .catch((err) => log(`Failed: ${err}`));
    } else {
      setLengthCarousel(0);
      dispatch({ type: types.addCourses, payload: [] });
      setLoading(false);
    }
    setValue(newValue);
  };

  return (
    <CoursesProvider>
      <Box className={classes.root}>
        <TitleLink
          textPrimary={dynamicTitleLink}
          textSecondary="Ver todos"
          onClick={(e) => handleClickInTitle(e)}
          className={classes.titleLink}
          hideSubtitleResponsive={hideShowMoreResponsive}
        />
        <Box className={clsx({ "position-relative": !courses.length && !finishSearch }, classes.carousel)}>
          {!courses.length && !finishSearch && (
            <Box position="relative" minHeight={317}>
              <CourseCardSkeleton />
            </Box>
          )}
          {!courses.length && finishSearch && (
            <NothingFound caption={noDataFound.caption} subcaption={noDataFound.subcaption} type={noDataFound.type} />
          )}
          {Boolean(courses.length) && (
            <Box
              position="relative"
              className={isDetail ? classes.hover_carousel + " " + classes.hover_carousel_detail : classes.hover_carousel}
            >
              {showTabs && <TabCarousel tabs={tabs} handleChange={handleChange} value={value} />}
              <SlickCarousel isDetail={isDetail} length={lengthCarousel} typeCard="normal" slidestoshow={1} slidestoscroll={1} variablewidth="true" slidemargin="0px">
                {courses.map((courseItem) => {
                  const isMembershipExpired = validateMembership(userMembership);
                  const accessAction = resolveAccessAction(courseItem, isMembershipExpired);

                  return (
                    <SwiperSlide className={classes.card} key={courseItem.id}>
                      <StatusCourseCard
                        courseId={courseItem.id}
                        sourceId={courseItem.source_id}
                        userId={parseInt(user?.person_id ?? 0)}
                        sourceIdLogo={getSourceBySourceAndCompany(courseItem.source_id, courseItem.company_id)}
                        enrollmentStatusId={courseItem?.enrollment_status_id}
                        companyId={courseItem?.company_id}
                        media={{
                          backgroundImage: courseItem?.image || convertSourceToImageResource(courseItem.company_id, courseItem.source_id),
                          modalityId: courseItem?.modality_id || 2,
                          percentage: courseItem?.lesson_percentage,
                        }}
                        content={{
                          courseName: courseItem?.name,
                          grade: courseItem?.progress_percentage,
                        }}
                        isLogged={true}
                        approved={false}
                        showDetailButton={false}
                        merbershipIsExpired={accessAction === ACCESS_ACTION.RENEW}
                        accessAction={accessAction}
                        onClickUpgrade={() => history.push(paths.MEMBRESIAS)}
                        handleRenovationMembership={(e) => manuallyAttemptMembershipPayment(e)}
                        onClickRegister={() =>
                          history.push({
                            pathname: generatePath(paths.CURSO_DETALLE, { id: courseItem.id }),
                            state: { prevPath: isMyCourses ? "mis_cursos" : "", target: null },
                          })
                        }
                      />
                    </SwiperSlide>
                  );
                })}
              </SlickCarousel>
            </Box>
          )}
          <Hidden smUp>
            <Box textAlign="center">
              <Button
                color="primary"
                endIcon={<Icon className="ri-arrow-right-s-line" style={{ fontSize: "24px !important" }} />}
                onClick={handleClickInTitle}
              >
                Ver todos
              </Button>
            </Box>
          </Hidden>
        </Box>
      </Box>
    </CoursesProvider>
  );
};

CourseCarousel.defaultProps = {
  lazyLoading: false,
  disableTitleAction: false,
  viewCourseDetails: false,
  urlMore: "",
  withoutPaddings: false,
  noDataFound: { caption: "", subcaption: "", type: "search" },
  hideShowMoreResponsive: false,
};

const mapStateToProps = (reducers) => reducers.userReducer;

export default React.memo(
  connect(mapStateToProps, {})(CourseCarousel),
  (prevProps, nextProps) => prevProps.show === nextProps.show,
);
